/**
 * Camp Card Renderer
 * Render individual camp cards using CampsUtils
 */

import { state } from '../core/state.js';
import { readUserGeoFromCache } from '../decision-engine/user-geo.js';

/**
 * Render a single camp card
 * Uses CampsUtils.renderCampCardHtml if available, otherwise fallback to simple card
 * @param {Object} camp - Camp object from Algolia
 * @returns {string} - HTML string for camp card
 */
export function renderCampCard(camp) {
  // For non-US users: hide distance if dates are entered OR if no location is specified
  const userGeo = readUserGeoFromCache();
  const hasDates = !!(state.beginDates && state.endDates);
  const hasLocation = !!(state.zip || '').trim();
  const isNonUS = userGeo?.isUS === false;
  const shouldHideDistance = isNonUS && (hasDates || !hasLocation);
  const showDistance = shouldHideDistance ? false : !!state.showDistance;

  // Use shared utility if available
  if (window.CampsUtils && window.CampsUtils.renderCampCardHtml) {
    return window.CampsUtils.renderCampCardHtml(camp, {
      showDistance: showDistance,
    });
  }

  // Fallback to simple card if CampsUtils not loaded
  const image = camp.featuredImage || '/themes/v2/img/default-img.jpg';
  const distance =
    showDistance && camp._rankingInfo && camp._rankingInfo.geoDistance
      ? (camp._rankingInfo.geoDistance / 1609).toFixed(1)
      : null;

  return `
            <li>
                <a href="${camp.url}" class="media tile cfix">
                    <div class="img">
                        <img src="${image}" alt="${camp.title}" />
                    </div>
                    <h3 class="flexible">${camp.title}</h3>
                    <p class="availability">${camp.availabilityDate || ''}</p>
                    ${
                      distance
                        ? `<p class="distance"><strong>${distance} miles away</strong></p>`
                        : ''
                    }
                    <div class="hidden campcode">${camp.code || ''}</div>
                </a>
            </li>
        `;
}

console.log('📦 Camp card module loaded');
